export const SET_ACTIVE_SIDE_INDEX = 'SET_ACTIVE_SIDE_INDEX'

export const setActiveSideIndex = data => async dispatch => {
  dispatch({
    type: SET_ACTIVE_SIDE_INDEX,
    payload: data
  })
}
